import { getters } from "@/constants/state";

export default {
  [getters.TEMPLATE_LOCATIONS_TEMPLATES_GETTER]: (state) => state.templates,
};
